module.exports = __webpack_public_path__ + "static/yr-logo-9dbcd9fa82af855dc50d3a8df4cbf91e.jpg";